import {Typography} from "@mui/material";
import {SmallLightTooltip} from "../components/core/Tooltip";

export let PMLTableColumn = [
    {
        title: "Master Category",
        field: "category_name",
        align: "center",
        width: '280px',
        render: (rowData) =>
            rowData.category_name && (
                <SmallLightTooltip
                    title={"Click > To view the bill line Item"}
                    placement="top"
                >
                    <Typography varient="p" fontSize={"14px"}>
                        {rowData.category_name}
                    </Typography>
                </SmallLightTooltip>
            ),
    },

    {
        title: "Tariff Amount",
        field: "tariffAmount",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.tariffAmount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.tariffAmount)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    {" "}
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Room Proportional Discount",
        field: "roomProportionalDiscount",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.roomProportionalDiscount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    {rowData.roomProportionalDiscount} &#x25;
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    0 &#x25;
                </Typography>
            ),
    },
    {
        title: "Amount After Room Proportional Discount",
        field: "amountAfterRoomProportionalDiscount",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.amountAfterRoomProportionalDiscount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amountAfterRoomProportionalDiscount)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    {" "}
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Mou Discount",
        field: "mouApplicable",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.mouApplicable !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    {Math.trunc(rowData.mouApplicable * 100) / 100} &#x25;
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    0 &#x25;
                </Typography>
            ),
    },
    {
        title: "Amount After Mou Discount",

        field: "amountAfterMou",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.amountAfterMou !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amountAfterMou)}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"} maxWidth={"100px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Limit",
        field: "limit",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.limit !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.limit)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },

    {
        title: "Amount Before Copay",
        field: "amountBeforeCopay",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.amountBeforeCopay !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amountBeforeCopay)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Copay",
        field: "copay",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.copay !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    {Math.trunc(rowData.copay)} &#x25;{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    0 &#x25;
                </Typography>
            ),
    },
    {
        title: "Final Amount",
        field: "finalAmount",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.finalAmount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.finalAmount)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Final Amount Sent To Jarvis",
        field: "finalAmountSentToJarvis",
        align: "right",
        headerStyle: {
            width: '140px'
        },
        width: '140px',
        render: (rowData) =>
            rowData && rowData.amountAfterDrop !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amountAfterDrop)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "Remarks",
        field: "remarks",
        width: '250px',
        render: (rowData) => rowData && rowData.remarks !== null ? (
                <Typography variant="p" fontSize={"14px"}>
                    {rowData.remarks} &#x25;{" "}
                </Typography>
            ) : (
                <Typography variant="p" fontSize={"14px"}>
                    N/A
                </Typography>
            ),
    },
    {
        title: "CM Deduction (%)",
        field: "cm_small_discount_percentage",
        align: "right",
        headerStyle: {
            width: '200px'
        },
        width: '200px',
        render: (rowData) =>
            rowData && rowData.cm_small_discount_percentage !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    {rowData.cm_small_discount_percentage}{" %"}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    0 &#x25;
                </Typography>
            ),
    },
    {
        title: "Amount After CM Deduction",
        field: "amount_after_cm_discount",
        align: "right",
        headerStyle: {
            width: '200px'
        },
        width: '200px',
        render: (rowData) =>
            rowData && rowData.amount_after_cm_discount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amount_after_cm_discount)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
        title: "SPOT Deduction (%)",
        field: "spot_discount_percentage",
        align: "right",
        headerStyle: {
            width: '200px'
        },
        width: '200px',
        render: (rowData) =>
            rowData && rowData.spot_discount_percentage !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    {rowData.spot_discount_percentage}{" %"}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    0 &#x25;
                </Typography>
            ),
    },
    {
        title: "Amount After SPOT Deduction",
        field: "amount_after_spot_discount",
        align: "right",
        headerStyle: {
            width: '200px'
        },
        width: '200px',
        render: (rowData) =>
            rowData && rowData.amount_after_spot_discount !== null ? (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; {Math.trunc(rowData.amount_after_spot_discount)}{" "}
                </Typography>
            ) : (
                <Typography varient="p" fontSize={"14px"}>
                    &#x20b9; 0
                </Typography>
            ),
    },
    {
            title: "Amount After Discount",
            field: "amount_after_discount",
            align: "right",
            headerStyle: {
                width: '200px'
            },
            width: '200px',
            render: (rowData) =>
                rowData && rowData.amount_after_discount !== null ? (
                    <Typography varient="p" fontSize={"14px"}>
                        &#x20b9; {Math.trunc(rowData.amount_after_discount)}{" "}
                    </Typography>
                ) : (
                    <Typography varient="p" fontSize={"14px"}>
                        &#x20b9; 0
                    </Typography>
                ),
        }
];
